export const state = {
  // product: undefined,
  // products: []
  film: {},
  films: [],
  pagination:''
}
